// extracted by mini-css-extract-plugin
export var customPlanStyles = "MembershipPlans_customPlanStyles__U0hlE";
export var planSectionTitle = "MembershipPlans_planSectionTitle__9lI9h";
export var planSectionWrapper = "MembershipPlans_planSectionWrapper__o4hIZ";